
/**
 * Slick setup
 */
$(document).ready(function () {

    // ----------------------------------------------
    // Slides (http://kenwheeler.github.io/slick/)
    // ----------------------------------------------

    $('.slide-list').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        customPaging: function (slider, i) {
            return '<div class="slide-dot">';
        },
        nextArrow: '<div class="slide-control next"></div>',
        prevArrow: '<div class="slide-control prev"></div>',
        slide: '.slide',
        arrows: false,
        dots: true,
        autoplay: true,
        autoplaySpeed: 13000,
        fade: true,
        cssEase: 'linear'
    });


    // ----------------------------------------------
    // Carousel (http://kenwheeler.github.io/slick/)
    // ----------------------------------------------
    $('.portletCarousel').slick({
        infinite: true,
        slidesToShow: 6,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1400,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false
                }
            },
            {
                breakpoint: 1000,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false
                }
            }
            // {
            //     breakpoint: 300,
            //     settings: {
            //         slidesToShow: 1,
            //         slidesToScroll: 1,
            //         dots: false
            //     }
            // }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ],
        // arrows: true,
        nextArrow: '<div class="slide-control next"></div>',
        prevArrow: '<div class="slide-control prev"></div>',
        dots: false
        //variableWidth: true
    });

});

